<div id="mobile-legend">
    <ng-container *ngIf="detailedLegend; else detailedLegendTemplate">
        <div class="legend-container-categories">
            <div class="legend-category" *ngFor="let category of legendCategories" [ngStyle]="{ 'background-color': category.color }">
              <span class="legend-label">{{ category.label | translate }}</span>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #detailedLegendTemplate>
    <div class="legend-container ol-control ol-attribute">
        <img src="../../../../assets/images/atlas_legend.png" class="legend" />
        <div class="legend-values">
            <div *ngFor="let value of legend.values" class="legend-value" [style.left]="value.position * 50 + '%'">
                <div class="legend-label">{{ value.label | translate }}</div>
                <div class="legend-mark"></div>
            </div>
        </div>
    </div>
</ng-template>
